import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { APP_TITLE } from 'src/common/models/config';
import { PageService } from 'src/common/services/page.service';

@Injectable({ providedIn: 'root' })
export class CombinedTitleStrategy extends TitleStrategy {
  private readonly pageService = inject(PageService);

  private getTitleData(routeSnapshot: ActivatedRouteSnapshot): string[] {
    let titles: string[];

    if (routeSnapshot.firstChild) {
      titles = this.getTitleData(routeSnapshot.firstChild);
    } else {
      titles = [];
    }
    const routeTitle = this.getResolvedTitleForRoute(routeSnapshot) as unknown;

    if (routeTitle && typeof routeTitle === 'string') {
      titles.unshift(routeTitle);
    } else if (routeSnapshot.component && 'title' in routeSnapshot.component) {
      if (typeof routeSnapshot.component.title === 'string') {
        titles.unshift(routeSnapshot.component.title);
      }
    } else if (routeSnapshot.routeConfig?.data?.['title']) {
      if (typeof routeSnapshot.routeConfig.data['title'] === 'string') {
        titles.unshift(routeSnapshot.routeConfig.data['title']);
      } else {
        titles.unshift(...routeSnapshot.routeConfig.data['title']);
      }
    }
    return titles;
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const titles = this.getTitleData(snapshot.root);
    titles.push(APP_TITLE);

    this.pageService.setBaseTitle(titles);
  }
}
